import { isInValidDate } from "../../../common/util";

export const validate = values => {
    const errors = {}
    if (!values.title) {
      errors.title = 'Title is required.'
    }

    if (!(values.SystemTags && values.SystemTags.length) && (!values.tags || values.tags.length === 0)) {
        errors.tags = 'Tag is required.'
    }

    if (!values.owner || values.owner == 0) {
        errors.owner = 'Owner is required.'
    }

    if (!values.DateTime) {
        errors.DateTime = "Due Date is required."
    }

    if(values.enableReminder && !values.ReminderDate) {
        errors.ReminderDate = "Reminder Date is required."
    }

    if(values.isDateComment && !values.dateChangeComment) {
        errors.dateChangeComment = "Comment is required."
    }

    if(values.DateTime && isInValidDate(values.DateTime))
    {
         errors.DateTime = "Due Date is invalid."

    }
    if(values.enableReminder && values.ReminderDate && isInValidDate(values.ReminderDate)) {

       errors.ReminderDate = "Reminder Date is invalid.";
    }

    if(values.followUpDueDate1 && isInValidDate(values.followUpDueDate1))
    {
        errors["followUpDueDate1"] = "Follow Up Date #1 is invalid.";

    }

    if( values.followUpDueDate2 && isInValidDate(values.followUpDueDate2))
    {
        errors["followUpDueDate2"] = "Follow Up Date #2 invalid.";
    }

    if( values.followUpDueDate3 && isInValidDate(values.followUpDueDate3))
    {
        errors["followUpDueDate3"] = "Follow Up Date #3 is invalid.";
    }

    return errors
  }